import { withInjection } from "/src/components/ui/util/with-injection";
import { APP_DEP } from "/src/config/configure-dependencies";
import { CardStatus, CardStatusProps } from "/src/pages/card-status/CardStatus";

export const InjectedCardStatus = withInjection<
  CardStatusProps,
  "cardManagementService" | "externalBizbankService"
>(CardStatus, {
  cardManagementService: APP_DEP.CARD_MANAGEMENT_SERVICE,
  externalBizbankService: APP_DEP.EXTERNAL_BIZBANK_SERVICE,
});
